import dayjs from "dayjs";
import { TripListTrip } from "../../hooks/react-query/linehaul/useLoadBoard";

export const loadTrips = {
  tripCount: 5,
  bills: 0,
  weight: 0,
  hasNotes: false,
  tripSummaries: [
    {
      loadBoardId: 3021063,
      tripNumber: 3025801,
      carrier: {
        id: 92278,
        name: "MARSA TRANSPORTATION INC",
        code: "M199",
        isActive: true,
      },
      originSic: {
        id: 114,
        code: "DAL",
        ownership: "C",
        lhRegionId: 135,
        timeZone: "America/Chicago",
      },
      stops: [],
      employeeDrivers: [],
      destinationSic: {
        id: 115,
        code: "HTX",
        ownership: "C",
        lhRegionId: 135,
        timeZone: "America/Chicago",
      },
      bookingNumber: "JOHN",
      trailerNumber: "",
      loadingDate: dayjs("2024-09-01T00:00:00"),
      pickupDate: dayjs("2024-09-02T01:00:00"),
      gateTime: null,
      closeDate: null,
      bills: 0,
      weight: 0,
      tags: [],
      sealNumber: "1234567",
      cubage: 85,
      status: "LDDK",
      driverCheckedIn: false,
      rolloverFee: 250,
      isLoadAndHold: true,
      hasNotes: false,
    },
    {
      loadBoardId: 3021063,
      tripNumber: 3025810,
      carrier: {
        id: 92278,
        name: "MARSA TRANSPORTATION INC",
        code: "M199",
        isActive: true,
      },
      originSic: {
        id: 114,
        code: "DAL",
        ownership: "C",
        lhRegionId: 135,
        timeZone: "America/Chicago",
      },
      stops: [],
      employeeDrivers: [],
      destinationSic: {
        id: 115,
        code: "HTX",
        ownership: "C",
        lhRegionId: 135,
        timeZone: "America/Chicago",
      },
      bookingNumber: "JOHN",
      trailerNumber: "",
      loadingDate: dayjs("2024-09-01T00:00:00"),
      pickupDate: dayjs("2024-09-02T01:00:00"),
      gateTime: dayjs("2024-09-05T02:00:00"),
      closeDate: null,
      bills: 0,
      weight: 0,
      tags: [],
      sealNumber: "",
      cubage: null,
      status: "CLOS",
      driverCheckedIn: false,
      rolloverFee: null,
      hasNotes: false,
    },
    {
      loadBoardId: 3021355,
      tripNumber: 3025969,
      carrier: {
        id: 92263,
        name: "MURILLO LOGISTIC INC",
        code: "M183",
        isActive: true,
      },
      originSic: {
        id: 114,
        code: "DAL",
        ownership: "C",
        lhRegionId: 135,
        timeZone: "America/Chicago",
      },
      stops: [],
      destinationSic: {
        id: 115,
        code: "HTX",
        ownership: "C",
        lhRegionId: 135,
        timeZone: "America/Chicago",
      },
      bookingNumber: "RALPH",
      trailerNumber: "",
      employeeDrivers: [],
      loadingDate: dayjs("2024-09-01T00:00:00"),
      pickupDate: dayjs("2024-09-02T21:00:00"),
      gateTime: null,
      closeDate: null,
      bills: 0,
      weight: 0,
      tags: [],
      sealNumber: "",
      cubage: null,
      status: "PLAN",
      driverCheckedIn: true,
      rolloverFee: null,
      hasNotes: false,
    },
    {
      loadBoardId: 3021344,
      tripNumber: 3025888,
      carrier: {
        id: 92263,
        name: "MURILLO LOGISTIC INC",
        code: "M183",
        isActive: true,
      },
      originSic: {
        id: 114,
        code: "DAL",
        ownership: "C",
        lhRegionId: 135,
        timeZone: "America/Chicago",
      },
      stops: ["ONT"],
      destinationSic: {
        id: 115,
        code: "HTX",
        ownership: "C",
        lhRegionId: 135,
        timeZone: "America/Chicago",
      },
      bookingNumber: "RALPH",
      trailerNumber: "",
      employeeDrivers: [],
      loadingDate: dayjs("2024-09-01T00:00:00"),
      pickupDate: dayjs("2024-09-02T21:00:00"),
      gateTime: null,
      closeDate: null,
      driverCheckedIn: false,
      bills: 0,
      weight: 0,
      tags: [],
      sealNumber: "",
      cubage: null,
      status: "LDDK",
      rolloverFee: null,
      hasNotes: false,
    },
    {
      loadBoardId: 3021063,
      tripNumber: 3025819,
      carrier: {
        id: 92278,
        name: "MARSA TRANSPORTATION INC",
        code: "M199",
        isActive: true,
      },
      originSic: {
        id: 114,
        code: "DAL",
        ownership: "C",
        lhRegionId: 135,
        timeZone: "America/New_York",
      },
      stops: [],
      employeeDrivers: [],
      destinationSic: {
        id: 115,
        code: "HTX",
        ownership: "C",
        lhRegionId: 135,
        timeZone: "America/Chicago",
      },
      bookingNumber: "JOHN",
      trailerNumber: "",
      loadingDate: dayjs("2024-09-01T00:00:00"),
      pickupDate: dayjs("2024-09-02T01:00:00"),
      gateTime: dayjs().add(1, "day").set("hour", 15).set("minute", 0),
      closeDate: null,
      bills: 0,
      weight: 0,
      tags: [],
      sealNumber: "",
      cubage: null,
      status: "CLOS",
      driverCheckedIn: false,
      rolloverFee: null,
      hasNotes: false,
    },
  ] satisfies TripListTrip[],
};

export const trailers = [
  {
    id: 23872,
    trailerNumber: "HTXGHOST30",
  },
  {
    id: 23904,
    trailerNumber: "ONTGHOST16",
  },
  {
    id: 23958,
    trailerNumber: "IB TRAP 2",
  },
];
